import React from "react";
import { Alert } from "@material-ui/lab";
import { StyledScrollTable, StyledTable, StyledTableBody, StyledTableHead } from "../../../styles/styledTable";
import PageSpinner from "../../../elements/spinner/PageSpinner";
import TelegramInvoicesItem from "./TelegramInvoicesItem";

const TelegramInvoicesList = ({ invoices, setNotification, t }) => {
  if (invoices === null) return <PageSpinner position="center" pt="20" pb="20" />;
  if (invoices.length === 0) return <Alert severity="warning">{t("invoices.table.emptyData")}</Alert>;

  return (
    <StyledScrollTable>
      <StyledTable width="1750" size="14" className="invoices">
        <StyledTableHead scroll="auto" col="13" className="invoices__head">
          <div>{t("invoices.table.inv")}</div>
          <div>{t("invoices.table.paymentId")}</div>
          <div>{t("invoices.table.project")}</div>
          <div>{t("invoices.table.chat")}</div>
          <div>{t("invoices.table.manager")}</div>
          <div>{t("invoices.table.type")}</div>
          <div>{t("invoices.table.amount")}</div>
          <div>{t("invoices.table.commission")}</div>
          <div>{t("invoices.table.total")}</div>
          <div>{t("invoices.table.currency")}</div>
          <div>{t("invoices.table.network")}</div>
          <div>{t("invoices.table.status")}</div>
          <div>{t("invoices.table.time")}</div>
        </StyledTableHead>
        <StyledTableBody>
          {invoices.map(invoice => (
            <TelegramInvoicesItem key={invoice.id} invoice={invoice} setNotification={setNotification} t={t} />
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledScrollTable>
  );
};

export default TelegramInvoicesList;